module.exports = __webpack_public_path__ + "img/logo.4a7da909.png";